import { deliveryStateChipLabel } from '../../../lib/deliveryStates';

export interface StateFilterOption {
  value: string;
  label: string;
}

// The dropdown's rows, labelled with the copy the agent reads and ordered by it. `localeCompare`
// with the Spanish locale rather than `<`: a plain comparison puts every accented initial after
// «Z», which reads as a bug in a list scanned alphabetically.
//
// A state with no copy still gets a row — it is a state backend really returns, and dropping it
// would read as «this state does not exist». The label resolver already falls open to the
// capitalized spelling, so there is nothing to decide here.
export function stateFilterOptions(states: string[]): StateFilterOption[] {
  return states
    .map((value) => ({ value, label: deliveryStateChipLabel(value) }))
    .sort((a, b) => a.label.localeCompare(b.label, 'es'));
}

// The APPLIED array, and a different ordering on purpose: by wire spelling, never by label. This
// array reaches a TanStack key and a request, both of which hash order-sensitively, while a
// multi-select emits in click order — so «expired then stored» and «stored then expired» would be
// two cache entries, two identical requests and two reported searches for one search. Ordering by
// label would re-key all of that the day product rewords a state.
//
// Copied before sorting: `sort` mutates, and the caller's array is not this function's to reorder.
export function canonicalStates(states: string[]): string[] {
  return [...states].sort((a, b) => a.localeCompare(b));
}
